/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Spinner,
  Button,
  Label,
  Tooltip,
  TabContent,
  TabPane,
  NavLink,
  NavItem,
  CardText,
  Nav,
  UncontrolledTooltip,
} from "reactstrap";

import Select from "react-select";

import SwitchEvent from "./AutomaticMessageSwitch";

import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import CustomFormRepeater from "../../components/Common/CustomFormRepeater";

//i18n
import { withTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

import schema from "./AutomaticMessageValidation.js";

import {
  getAutomaticMessage,
  editAutomaticMessage,
  resetAutomaticMessage,
  resetAutomaticMessages,
  resetError,
} from "../../store/automaticmessages/actions";

import "./AutomaticMessage.scss";

const NewAutomaticMessage = ({ t }) => {
  let { idAutomaticMessage } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const { register, handleSubmit, setValue, errors } = useForm({
    resolver: yupResolver(schema),
  });

  const {
    dataAutomaticMessageGetSet,
    dataAutomaticMessageEditCreate,
    loadingAutomaticMessage,
    loadingAutomaticMessageEditCreate,
    successAutomaticMessage,
    errorAutomaticMessage,
  } = useSelector((state) => state.AutomaticMessage);

  const [newFields, setNewFields] = useState({});
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [messageAdded, setMessageAdded] = useState(false);
  const [customMessageAdded, setCustomMessageAdded] = useState([]);

  const [activeTab, setActiveTab] = useState(0);

  const [automaticMessageValues, setAutomaticMessageValues] = useState({
    name: "",
    nameBk: "",

    description: "",
    descriptionBk: "",

    text: "",
    textBk: "",

    active: [],
    activeBk: [],

    custom_text_skill: [],
    custom_text_skillBk: [],
  });

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [tooltipObj, setTooltipObj] = useState(null);

  const showToast = useCallback(
    (type, message) => {
      toastr[type](message);
    },
    [successAutomaticMessage]
  );
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successAutomaticMessage &&
      dispatch(resetAutomaticMessage()) &&
      dispatch(resetAutomaticMessages()) &&
      history.push("/automatic-messages"),
  };

  const handleCreateEditAutomaticMessage = () => {
    if (idAutomaticMessage) {
      delete newFields.name;
      dispatch(editAutomaticMessage(idAutomaticMessage, newFields));
    } else {
      //Uncomment if client can create automaticmessage
      // dispatch(createAutomaticMessage(newFields));
    }
  };

  const newAutomaticMessageSubmit = () => {
    handleCreateEditAutomaticMessage();
  };

  const checkSwitchEvent = (field, values) => {
    let valuesBk = field + "Bk";
    if (values === automaticMessageValues[valuesBk]) {
      delete newFields[field];
      checkSubmit();
    } else {
      setNewFields((prev) => ({
        ...prev,
        [field]: values,
      }));
    }
  };

  const equalArrays = (a, b) => {
    if (a?.length !== b?.length) return false;
    const ser = (o) =>
      JSON.stringify(
        Object.keys(o)
          .sort()
          .map((k) => [k, o[k]])
      );
    a = new Set(a.map(ser));
    return b.every((o) => a.has(ser(o)));
  };

  const checkName = (values, valuesBk) => {
    if (values === valuesBk) {
      delete newFields.name;
      checkSubmit();
    } else {
      setNewFields({
        ...newFields,
        name: values,
      });
    }
  };

  const checkDescription = (values, valuesBk) => {
    if (values === valuesBk) {
      delete newFields.description;
      checkSubmit();
    } else {
      setNewFields({
        ...newFields,
        description: values,
      });
    }
  };

  const checkText = (values, valuesBk) => {
    if (equalArrays(values, valuesBk)) {
      delete newFields.text;
      checkSubmit();
    } else {
      setNewFields({
        ...newFields,
        text: values,
      });
    }
  };

  const checkCustomTextSkill = (values, valuesBk) => {
    if (equalArrays(values, valuesBk)) {
      delete newFields.custom_text_skill;
      checkSubmit();
    } else {
      setNewFields({
        ...newFields,
        custom_text_skill: values,
      });
    }
  };

  const optionsSkills = () => {
    let skills = [];

    if (dataAutomaticMessageGetSet?.data?.form?.skills?.length > 0) {
      dataAutomaticMessageGetSet.data.form.skills.map((skill) =>
        skills.push({
          key: skill.id,
          value: skill.id,
          label: skill.name,
        })
      );
    } else {
      if (loadingAutomaticMessage) {
        skills.push({
          value: "loading",
          label: t("Loading..."),
          isDisabled: true,
        });
      } else {
        skills.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    return skills;
  };

  const checkSubmit = () => {
    if (Object.keys(newFields).length > 0) {
      setEnableSubmit(true);
    } else {
      setEnableSubmit(false);
    }
  };

  useEffect(() => {
    if (idAutomaticMessage) {
      dispatch(getAutomaticMessage(idAutomaticMessage, true));
    } else {
      dispatch(getAutomaticMessage(null, true));
    }
  }, []);

  useEffect(() => {
    if (
      idAutomaticMessage &&
      dataAutomaticMessageGetSet &&
      dataAutomaticMessageGetSet?.data?.message &&
      !loadingAutomaticMessage
    ) {
      setAutomaticMessageValues({
        ...automaticMessageValues,
        name: dataAutomaticMessageGetSet.data.message.name,
        nameBk: dataAutomaticMessageGetSet.data.message.name,

        description: dataAutomaticMessageGetSet.data.message.description,
        descriptionBk: dataAutomaticMessageGetSet.data.message.description,

        text: dataAutomaticMessageGetSet.data.message.text,
        textBk: dataAutomaticMessageGetSet.data.message.text,

        active: dataAutomaticMessageGetSet.data.message.active,
        activeBk: dataAutomaticMessageGetSet.data.message.active,

        custom_text_skill:
          dataAutomaticMessageGetSet.data.message.custom_text_skill,
        custom_text_skillBk:
          dataAutomaticMessageGetSet.data.message.custom_text_skill,
      });
    }

    if(dataAutomaticMessageGetSet?.data.message?.text?.length){
      setMessageAdded(true);
    }
    if(dataAutomaticMessageGetSet?.data.message.custom_text_skill?.length){
     const aux = dataAutomaticMessageGetSet?.data.message.custom_text_skill?.filter((el) => el.text?.length === 1);
     const skillsIds = aux.map((el) => el.skill_id);
     setCustomMessageAdded(skillsIds)
    }
  }, [dataAutomaticMessageGetSet]);

  useEffect(() => {
    automaticMessageValues?.text &&
      setValue("automaticmessagetext", automaticMessageValues.text, {
        shouldValidate: true,
      });

    automaticMessageValues?.custom_text_skill &&
      setValue(
        "automaticmessagecustomtextskill",
        automaticMessageValues.custom_text_skill,
        { shouldValidate: true }
      );
  }, [automaticMessageValues]);

  useEffect(() => {
    if (dataAutomaticMessageEditCreate?.message) {
      showToast("success", t(dataAutomaticMessageEditCreate.message));
    }
  }, [successAutomaticMessage]);

  useEffect(() => {
    if (errorAutomaticMessage && typeof Array.isArray(errorAutomaticMessage)) {
      errorAutomaticMessage.map((error) => showToast("error", t(error.value)));
      dispatch(resetError());
    } else {
      if (errorAutomaticMessage) {
        showToast("error", t(errorAutomaticMessage));
        dispatch(resetError());
      }
    }
  }, [errorAutomaticMessage]);

  useEffect(() => {
    checkSubmit();
  }, [newFields]);

  const setClassName = (errors, classname) => {
    return errors ? "av-invalid is-invalid " + classname : classname;
  };

  useEffect(() => {
    setTooltipOpen(true);
    setTimeout(() => {
      setTooltipOpen(false);
    }, 1500);
  }, [tooltipObj]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/automatic-messages"
            path={"/automatic-message"}
            title={t("Automatic Messages")}
            breadcrumbItem={
              idAutomaticMessage
                ? t("Edit Automatic Message")
                : t("Create automatic message")
            }
          />
          <Row>
            <Col xs="12" className="customContent">
              <Card>
                <CardBody>
                  <form onSubmit={handleSubmit(newAutomaticMessageSubmit)}>
                    <Row className="mb-3 justify-content-between">
                      <Col className="pr-2" lg="7">
                        <Row>
                          <Col md="12">
                            <FormGroup>
                              <Label id="automatic-message-name-label">
                                {t("Name")}
                              </Label>
                              <input
                                type="text"
                                name="automaticmessagename"
                                ref={register}
                                className={setClassName(
                                  errors.automaticMessagename,
                                  "form-control"
                                )}
                                placeholder={t("Enter automatic message name")}
                                disabled
                                onChange={(e) => {
                                  setAutomaticMessageValues({
                                    ...automaticMessageValues,
                                    name: e.target.value,
                                  });
                                  checkName(
                                    e.target.value,
                                    automaticMessageValues.nameBk
                                  );
                                }}
                                defaultValue={automaticMessageValues.name}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.automaticmessagename?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup>
                              <Label id="automatic-message-description-label">
                                {t("Description")}
                              </Label>
                              <input
                                type="text"
                                name="automaticmessagedescription"
                                ref={register}
                                className={setClassName(
                                  errors.automaticmessagedescription,
                                  "form-control"
                                )}
                                placeholder={t(
                                  "Enter automatic message description"
                                )}
                                onChange={(e) => {
                                  setAutomaticMessageValues({
                                    ...automaticMessageValues,
                                    description: e.target.value,
                                  });
                                  checkDescription(
                                    e.target.value,
                                    automaticMessageValues.descriptionBk
                                  );
                                }}
                                defaultValue={
                                  automaticMessageValues.description
                                }
                                disabled
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.automaticmessagedescription?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Col xs="12">
                          <SwitchEvent
                            id="activeComponent"
                            title="Active"
                            tooltip="This button active and deactivate this Automatic Message."
                            value={automaticMessageValues.active}
                            onChange={(val) => {
                              setAutomaticMessageValues((prev) => ({
                                ...prev,
                                active: val,
                              }));
                              checkSwitchEvent("active", val);
                            }}
                          />
                        </Col>
                        <Row>
                          <Col md="12">
                            <FormGroup>
                              <CustomFormRepeater
                                active={messageAdded}
                                outputTextArea={true}
                                inputRowProps={{ className: "d-flex" }}
                                outputRowProps={{
                                  className: "d-flex",
                                }}
                                buttonColProps={{
                                  className: "mb-3",
                                  sm: 3,
                                }}
                                actionLabel={t("Action")}
                                errorText={t("Fill all fields")}
                                addButtonText={t("Add")}
                                addButtonProps={{
                                  type: "button",
                                  color: "success",
                                  className:
                                    "waves-effect waves-light w-100 mr-2",
                                }}
                                deleteButtonText={t("Delete")}
                                deleteButtonProps={{
                                  type: "button",
                                  color: "danger",
                                  className:
                                    "waves-effect waves-light w-100 mr-2",
                                }}
                                outputProps={{
                                  className:
                                    "d-flex form-control autoGrowthInput",
                                  type: "text",
                                }}
                                fields={[
                                  {
                                    label: t("message") + " *",
                                    name: "text",
                                    textarea: true,
                                    colProps: { className: "mb-3" },
                                    labelProps: {
                                      className: "font-weight-light",
                                    },
                                    inputProps: {
                                      ref: register({
                                        name: "automaticmessagetext",
                                      }),
                                      className: setClassName(
                                        errors?.automaticmessagetext,
                                        "form-control autoGrowthInput"
                                      ),
                                      placeholder: t("Enter message") + "...",
                                      height: "100px",
                                      maxLength: "255",
                                    },
                                  },
                                ]}
                                value={automaticMessageValues.text}
                                onChange={(e) => {
                                  if(e?.length){
                                    setMessageAdded(true);
                                  } else{
                                    setMessageAdded(false);
                                  }
                                  setValue("automaticmessagetext", e, {
                                    shouldValidate: true,
                                  });
                                  setAutomaticMessageValues({
                                    ...automaticMessageValues,
                                    text: e,
                                  });
                                  checkText(e, automaticMessageValues.textBk);
                                }}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.automaticmessagetext?.message)}
                                {Array.isArray(errors.automaticmessagetext) &&
                                  errors?.automaticmessagetext?.map((item) =>
                                    t(item?.text?.message)
                                  )}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <Label id="automatic-message-description-label">
                              {t("Custom skill message")}
                            </Label>
                            <FormGroup className="select2-container">
                              <Select
                                name="automaticmessageskill"
                                ref={() =>
                                  register({ name: "automaticmessageskill" })
                                }
                                classNamePrefix="select2-selection"
                                className={setClassName(
                                  errors.automaticmessageskill,
                                  " select2-selection"
                                )}
                                placeholder={t("Choose") + "..."}
                                options={optionsSkills()}
                                onChange={(e) => {
                                  if (e) {
                                    let aux = {
                                      ...automaticMessageValues,
                                      custom_text_skill:
                                        !automaticMessageValues?.custom_text_skill.some(
                                          (item) => item.skill_id === e.value
                                        )
                                          ? [
                                              ...automaticMessageValues?.custom_text_skill,
                                              {
                                                skill_id: e.value,
                                                skill_name: e.label,
                                                active: true,
                                              },
                                            ]
                                          : automaticMessageValues?.custom_text_skill,
                                    };
                                    setAutomaticMessageValues(aux);
                                    setActiveTab(
                                      aux?.custom_text_skill?.findIndex(
                                        (item) => item.skill_id === e.value
                                      )
                                    );
                                    checkCustomTextSkill(
                                      aux?.custom_text_skill,
                                      automaticMessageValues?.custom_text_skillBk
                                    );
                                  }
                                }}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.automaticmessageskill?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            {automaticMessageValues?.custom_text_skill?.length >
                              0 && (
                              <div className="mb-3">
                                <Nav tabs>
                                  {automaticMessageValues?.custom_text_skill.map(
                                    (element, key) => (
                                      <NavItem key={key}>
                                        <NavLink
                                          style={{ cursor: "pointer" }}
                                          className={`pr-1 skill-link ${
                                            (errors
                                              ?.automaticmessagecustomtextskill
                                              ?.length > 0 &&
                                              errors
                                                ?.automaticmessagecustomtextskill[
                                                key
                                              ]?.text?.message) ||
                                            (errors
                                              ?.automaticmessagecustomtextskill
                                              ?.length > 0 &&
                                              errors
                                                ?.automaticmessagecustomtextskill[
                                                key
                                              ]?.text?.length > 0 &&
                                              errors?.automaticmessagecustomtextskill[
                                                key
                                              ]?.text?.map((item) =>
                                                t(item?.text?.message)
                                              ))
                                              ? "has-error"
                                              : ""
                                          } ${
                                            activeTab === key
                                              ? "active bg-primary"
                                              : ""
                                          }`}
                                        >
                                          <div className="d-inline-flex justify-content-between">
                                            <div
                                              onClick={() => {
                                                setActiveTab(key);
                                              }}
                                            >
                                              {element.skill_name}
                                            </div>
                                            <div
                                              id="tooltip-delete-message"
                                              className="delete-message-icon ml-2"
                                              onClick={() => {
                                                let itemIndex = automaticMessageValues?.custom_text_skill?.findIndex(
                                                  (item) =>
                                                    item.skill_id ===
                                                    element.skill_id
                                                );
                                                if (
                                                  itemIndex <= activeTab &&
                                                  activeTab !== 0
                                                ) {
                                                  setActiveTab(activeTab - 1);
                                                }
                                                let aux = {
                                                  ...automaticMessageValues,
                                                  custom_text_skill: automaticMessageValues?.custom_text_skill.filter(
                                                    (item) =>
                                                      item.skill_id !==
                                                      element.skill_id
                                                  ),
                                                };
                                                const customAux = customMessageAdded.filter((el) => el !== element.skill_id)
                                                setCustomMessageAdded(customAux)
                                                setAutomaticMessageValues(aux);
                                                checkCustomTextSkill(
                                                  aux.custom_text_skill,
                                                  automaticMessageValues.custom_text_skillBk
                                                );
                                              }}
                                            >
                                              <i className="mdi mdi-close" />
                                              <UncontrolledTooltip
                                                placement="top"
                                                target="tooltip-delete-message"
                                              >
                                                {t("Delete")}
                                              </UncontrolledTooltip>
                                            </div>
                                          </div>
                                        </NavLink>
                                      </NavItem>
                                    )
                                  )}
                                </Nav>
                                <TabContent activeTab={activeTab}>
                                  {automaticMessageValues?.custom_text_skill.map(
                                    (element, key) => (
                                      <TabPane
                                        key={key}
                                        tabId={key}
                                        className="skill-tab-pane p-3"
                                      >
                                        <Row>
                                          <Col sm="12">
                                            <CardText>
                                              <FormGroup>
                                                <Col xs="12">
                                                  <SwitchEvent
                                                    id="activeComponentCustom"
                                                    title="Active"
                                                    tooltip="This button active and deactivate this Automatic Message."
                                                    value={
                                                      (automaticMessageValues?.custom_text_skill &&
                                                        automaticMessageValues
                                                          ?.custom_text_skill[
                                                          key
                                                        ]?.active) ??
                                                      []
                                                    }
                                                    onChange={(value) => {
                                                      let aux = {
                                                        ...automaticMessageValues,
                                                        custom_text_skill:
                                                          automaticMessageValues?.custom_text_skill.map(
                                                            (e) =>
                                                              e.skill_id ===
                                                              element.skill_id
                                                                ? {
                                                                    ...e,
                                                                    active:
                                                                      value,
                                                                  }
                                                                : e
                                                          ),
                                                      };
                                                      setAutomaticMessageValues(
                                                        aux
                                                      );
                                                      checkCustomTextSkill(
                                                        aux.custom_text_skill,
                                                        automaticMessageValues.custom_text_skillBk
                                                      );
                                                    }}
                                                  />
                                                </Col>
                                                <CustomFormRepeater
                                                  active={customMessageAdded.includes(element.skill_id)}
                                                  outputTextArea={true}
                                                  inputRowProps={{
                                                    className: "d-flex",
                                                  }}
                                                  outputRowProps={{
                                                    className: "d-flex",
                                                  }}
                                                  buttonColProps={{
                                                    className: "mb-3",
                                                    sm: 3,
                                                  }}
                                                  actionLabel={t("Action")}
                                                  errorText={t(
                                                    "Fill all fields"
                                                  )}
                                                  addButtonText={t("Add")}
                                                  addButtonProps={{
                                                    type: "button",
                                                    color: "success",
                                                    className:
                                                      "waves-effect waves-light w-100 mr-2",
                                                  }}
                                                  deleteButtonText={t("Delete")}
                                                  deleteButtonProps={{
                                                    type: "button",
                                                    color: "danger",
                                                    className:
                                                      "waves-effect waves-light w-100 mr-2",
                                                  }}
                                                  outputProps={{
                                                    className:
                                                      "d-flex form-control autoGrowthInput",
                                                    type: "text",
                                                  }}
                                                  fields={[
                                                    {
                                                      label:
                                                        t("message") + " *",
                                                      name: "text",
                                                      textarea: true,
                                                      colProps: {
                                                        className: "mb-3",
                                                      },
                                                      labelProps: {
                                                        className:
                                                          "font-weight-light",
                                                      },
                                                      inputProps: {
                                                        ref: register({
                                                          name: "automaticmessagecustomtextskill",
                                                        }),
                                                        className: setClassName(
                                                          errors
                                                            ?.automaticmessagecustomtextskill
                                                            ?.length > 0 &&
                                                            errors
                                                              ?.automaticmessagecustomtextskill[
                                                              key
                                                            ]?.text?.message,
                                                          "form-control autoGrowthInput"
                                                        ),
                                                        placeholder:
                                                          t("Enter message") +
                                                          "...",
                                                        height: "100px",
                                                        type: "text",
                                                        maxLength: "255",
                                                      },
                                                    },                                        
                                                  ]}
                                                  value={
                                                    (automaticMessageValues?.custom_text_skill &&
                                                      automaticMessageValues
                                                        ?.custom_text_skill[key]
                                                        ?.text) ??
                                                    []
                                                  }
                                                  onChange={(value) => {
                                                    if(value?.length){
                                                      setCustomMessageAdded((prev) => [...prev, element.skill_id])
                                                    } else{
                                                      const aux = customMessageAdded.filter((el) => el !== element.skill_id)
                                                      setCustomMessageAdded(aux)
                                                    }
                                                    
                                                    let aux = {
                                                      ...automaticMessageValues,
                                                      custom_text_skill: automaticMessageValues?.custom_text_skill.map(
                                                        (e) =>
                                                          e.skill_id ===
                                                          element.skill_id
                                                            ? {
                                                                ...e,
                                                                text: value,
                                                              }
                                                            : e
                                                      ),
                                                    };
                                                    setAutomaticMessageValues(
                                                      aux
                                                    );
                                                    checkCustomTextSkill(
                                                      aux.custom_text_skill,
                                                      automaticMessageValues.custom_text_skillBk
                                                    );
                                                  }}
                                                />
                                                <div className="invalid-feedback d-block">
                                                  {errors
                                                    ?.automaticmessagecustomtextskill
                                                    ?.length > 0 &&
                                                    t(
                                                      errors
                                                        ?.automaticmessagecustomtextskill[
                                                        key
                                                      ]?.text?.message
                                                    )}
                                                  {errors
                                                    ?.automaticmessagecustomtextskill
                                                    ?.length > 0 &&
                                                    errors
                                                      ?.automaticmessagecustomtextskill[
                                                      key
                                                    ]?.text?.length > 0 &&
                                                    errors?.automaticmessagecustomtextskill[
                                                      key
                                                    ]?.text?.map((item) =>
                                                      t(item?.text?.message)
                                                    )}
                                                </div>
                                              </FormGroup>
                                            </CardText>
                                          </Col>
                                        </Row>
                                      </TabPane>
                                    )
                                  )}
                                </TabContent>
                              </div>
                            )}
                          </Col>
                        </Row>
                      </Col>
                      <Col lg="5">
                        <Row>
                          <Col md="12">
                            <Label className="w-100">{t("Keywords")}</Label>
                            <div className="font-size-12 mb-3">
                              <span>
                                {t(
                                  "The keywords below can be used on message to show dynamic data, click below to copy them"
                                )}
                              </span>
                            </div>
                            <div className="keywords-notepad font-size-11">
                              <div className="keywords-notepad item">
                                <ul className="px-3 mb-0">
                                  {dataAutomaticMessageGetSet?.data?.form?.keywords
                                    ?.sort((a, b) => (a.word < b.word ? -1 : 1))
                                    ?.map((item, key) => (
                                      <li
                                        key={key}
                                        className="mb-1 keywords-li"
                                        onClick={() => {
                                          navigator.clipboard.writeText(
                                            item?.word
                                          );
                                          setTooltipObj({
                                            target: `keywords-li-${key}`,
                                            message: `${item?.word} ${t(
                                              "Copied to keyboard!"
                                            )}`,
                                          });
                                        }}
                                      >
                                        <div
                                          id={`keywords-li-${key}`}
                                          className="keywords-li label "
                                        >
                                          {item?.word}
                                        </div>
                                        {" - "}
                                        <span>{item?.messages[0]?.text}</span>
                                        {"  "}
                                        <i className="mdi mdi-content-copy" />
                                      </li>
                                    ))}
                                </ul>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    {tooltipOpen && tooltipObj && (
                      <Tooltip
                        placement="auto"
                        isOpen={tooltipOpen}
                        target={tooltipObj?.target}
                      >
                        <div className="keywords-tooltip">
                          {tooltipObj?.message}
                        </div>
                      </Tooltip>
                    )}

                    <Button
                      type="submit"
                      color="primary"
                      className="mr-1 waves-effect waves-light"
                      style={{
                        minWidth: "100px",
                        cursor: enableSubmit ? "pointer" : "no-drop",
                      }}
                      disabled={!enableSubmit}
                    >
                      {loadingAutomaticMessageEditCreate ? (
                        <Spinner
                          size="sm"
                          animation="border"
                          style={{
                            height: "19px",
                            width: "19px",
                          }}
                        />
                      ) : (
                        t("Confirm")
                      )}
                    </Button>
                    <Link to="/automatic-messages">
                      <Button
                        type="button"
                        color="secondary"
                        className="waves-effect btn-dark"
                        onClick={() => dispatch(resetAutomaticMessage())}
                      >
                        {t("Cancel")}
                      </Button>
                    </Link>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(NewAutomaticMessage);
